// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimForApprovalContributions from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-contributions';
import {FormattedMessage} from 'react-intl';
import {buildCurrency} from '../../../shared/services/build-number';

const Contributions = props =>
    <section className='contributions'>
        <header>
            <FormattedMessage
                id='DEALER_SUBMISSION_WITH_CURRENCY'
                values={{currency: props.currency}}
            />
        </header>
        <ul className='column-headers'>
            <li>
                <FormattedMessage id='CUSTOMER'/>
            </li>
            <li>
                <FormattedMessage id='DEALER'/>
            </li>
            <li>
                <FormattedMessage id='COMPANY'/>
            </li>
            <li className='total'>
                <FormattedMessage id='TOTAL'/>
            </li>
        </ul>
        <ul className='data'>
            <li>
                {buildCurrency(props.contributions.customer)}
            </li>
            <li>
                {buildCurrency(props.contributions.dealer)}
            </li>
            <li>
                {buildCurrency(props.contributions.company)}
            </li>
            <li className='total'>
                {buildCurrency(props.contributions.total)}
            </li>
        </ul>
    </section>;

Contributions.displayName = 'Contributions';
Contributions.propTypes = {
    contributions: PropTypes.instanceOf(ClaimForApprovalContributions).isRequired,
    currency: PropTypes.string.isRequired
};

export default Contributions;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/contributions.js